import { Paper } from '@mui/material'
import { withStyles } from '@mui/styles'

export const BigPaper = withStyles({
  root: {
    borderRadius: 16
  }
})(Paper)
